import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { fromAuth, fromRouting } from 'store/selectors'

const requiresAuth = (AuthenticatedComponent, loginPathName) => {
  const Authentication = ({ isLoggedIn, redirectPathname, ...rest }) =>
    isLoggedIn ? (
      <AuthenticatedComponent {...rest} />
    ) : (
      <Redirect
        push
        to={{
          pathname: loginPathName || '/login',
          state: { redirectPathname },
        }}
      />
    )

  Authentication.propTypes = {
    isLoggedIn: PropTypes.bool,
    redirectPathname: PropTypes.string,
  }

  const mapStateToProps = state => ({
    isLoggedIn: fromAuth.isLoggedIn(state),
    redirectPathname:
      fromRouting.getPathname(state) + fromRouting.getSearch(state),
  })

  return connect(mapStateToProps)(Authentication)
}

export default requiresAuth
